var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t("module.speed")))]),_vm._v(" "),_c('el-slider',{attrs:{"step":1,"min":1,"max":_vm.speeds.length,"show-stops":""},model:{value:(_vm.speed),callback:function ($$v) {_vm.speed=$$v},expression:"speed"}})],1)]),_vm._v(" "),_c('div',{attrs:{"id":"goz_esnetme"}},[_c('div',{staticStyle:{"position":"absolute","font-size":"20px"},style:({
        top: _vm.top + 'px',
        left: _vm.left + 'px',
        transform: 'rotate(' + _vm.rotate + 'deg)',
        transformOrigin: _vm.rotate < 0 ? 'center' : 'center',
      })},[_vm._v("\n      "+_vm._s(_vm.word)+"\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c656a3a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/GozEsnekligi.vue
// module id = null
// module chunks = 